import MyAccountUpdatePaymentPage from './MyAccountUpdatePaymentPage'

export default MyAccountUpdatePaymentPage
// eslint-disable-next-line import/export
export * from './MyAccountUpdatePaymentPage'
